/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Label, Col, Row, Button, InputGroup, Input,
} from 'reactstrap';

import {
  Field, useFormikContext, ErrorMessage,
} from 'formik';

import * as url from '../../helpers/url_helper';

import BaseGrid from '../Common/BaseGrid';

function SupplierItemSelector(props) {
  // eslint-disable-next-line no-unused-vars
  const { onChange, index, t } = props;

  const [createMode, setCreateMode] = useState(false);
  const [itemSearch, setItemSearch] = useState(false);
  const { values, setFieldValue } = useFormikContext();

  const [linkedItem, setLinkedItem] = useState(null);
  const selectedLinkedItem = linkedItem
    || values.items?.[index]?.supplier_item?.linked_item
    || null;

  const toLinkedItemSummary = (item) => {
    if (!item) {
      return null;
    }

    return {
      id: item.id,
      manufacturer: item.manufacturer,
      part_number: item.part_number,
      sku: item.sku,
    };
  };

  const handleCreate = () => {
    setCreateMode(true);
  };

  const jsx = (
    <div>
      {createMode === true && (
        <div>
          <h6>{t('Create a new supplier item')}</h6>
          <Row>
            <Col md="5">
              <Label for={`items[${index}]_supplier_sku`}>{t('Supplier Sku')}</Label>
              <Field id={`items[${index}]_supplier_sku`} name={`items[${index}].supplier_item.supplier_sku`} className="form-control form-control-sm" />
            </Col>
            <Col md="3">
              <Label for={`items[${index}]_supplier_lead_time`}>{t('Lead Time (days)')}</Label>
              <Field type="number" id={`items[${index}]_supplier_lead_time`} name={`items[${index}].supplier_item.lead_time`} className="form-control form-control-sm" />
            </Col>
            <Col md="4">
              <Label for={`items[${index}]_qty`}>
                {props.t('Expected Qty')}
              </Label>
              <InputGroup size="sm">
                <span className="input-group-text">
                  <span className="mdi mdi-window-close" />
                </span>
                <Field name={`items[${index}].qty`} id={`items[${index}]_qty`} min="1" step="1" type="number" className="form-control" />
              </InputGroup>
              <ErrorMessage
                name={`items[${index}].qty`}
                component="div"
                className="text-danger"
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md="5">
              <Label for={`items[${index}]_supplier_notes`}>{t('Item Notes')}</Label>
              <Field as="textarea" id={`items[${index}]_supplier_notes`} name={`items[${index}].supplier_item.notes`} className="form-control form-control-sm" />
            </Col>
            {itemSearch === false && selectedLinkedItem === null && (
              <>
                <Col md="3">
                  <Label for={`items[${index}]_supplier_linked_item`}>{t('Linked Item')}</Label>
                  <InputGroup size="sm">
                    <Input className="form-control" readOnly value={t('Not linked')} id={`items[${index}]_supplier_linked_item`} />
                    <Button color="warning" onClick={() => { setItemSearch(true); }}>
                      <span className="mdi mdi-nfc-search-variant" />
                    </Button>
                  </InputGroup>
                </Col>

                <Col md="4">
                  <Label for={`items[${index}]_price`}>
                    {props.t('Cost')}
                  </Label>
                  <InputGroup size="sm">
                    <span className="input-group-text">
                      <span className="bx bx-dollar" />
                    </span>
                    <Field name={`items[${index}].price`} id={`items[${index}]_price`} step=".01" min="0" type="number" className="form-control" />
                  </InputGroup>
                  <ErrorMessage
                    name={`items[${index}].price`}
                    component="div"
                    className="text-danger"
                  />
                </Col>
              </>
            )}

            {itemSearch === false && selectedLinkedItem !== null && (
              <>
                <Col md="4">
                  <Label for={`items[${index}]_supplier_linked_item`}>{t('Linked Item')}</Label>
                  <InputGroup size="sm">
                    <Input name={`items[${index}].supplier_item.linked_item`} className="form-control" readOnly value={`${selectedLinkedItem.manufacturer} ${selectedLinkedItem.part_number}`} id={`items[${index}]_supplier_linked_item`} />
                    <Button
                      color="warning"
                      onClick={() => {
                        setItemSearch(false);
                        setLinkedItem(null);
                        setFieldValue(`items[${index}].supplier_item.linked_item`, null);
                      }}
                    >
                      <span className="mdi mdi-close-thick" />
                    </Button>
                  </InputGroup>
                </Col>

                <Col md="3">
                  <Label for={`items[${index}]_price`}>
                    {props.t('Cost')}
                  </Label>
                  <InputGroup size="sm">
                    <span className="input-group-text">
                      <span className="bx bx-dollar" />
                    </span>
                    <Field name={`items[${index}].price`} id={`items[${index}]_price`} step=".01" min="0" type="number" className="form-control" />
                  </InputGroup>
                  <ErrorMessage
                    name={`items[${index}].price`}
                    component="div"
                    className="text-danger"
                  />
                </Col>
              </>
            )}

            {itemSearch === true && (
              <>
                <Col md="3">
                  <Label for={`items[${index}]_supplier_linked_item`}>{t('Linked Item')}</Label>
                  <InputGroup size="sm">
                    <Input className="form-control" readOnly value={t('Waiting...')} id={`items[${index}]_supplier_linked_item`} />
                    <Button color="warning" disabled>
                      <span className="mdi mdi-nfc-search-variant" />
                    </Button>
                  </InputGroup>
                </Col>
                <Col md="4">
                  <Label for={`items[${index}]_price`}>
                    {props.t('Cost')}
                  </Label>
                  <InputGroup size="sm">
                    <span className="input-group-text">
                      <span className="bx bx-dollar" />
                    </span>
                    <Field name={`items[${index}].price`} id={`items[${index}]_price`} step=".01" min="0" type="number" className="form-control" />
                  </InputGroup>
                  <ErrorMessage
                    name={`items[${index}].price`}
                    component="div"
                    className="text-danger"
                  />
                </Col>
              </>
            )}
          </Row>
          {itemSearch === true && (
            <Row>
              <Col md="12">
                <BaseGrid
                  url="/api/items"
                  hasSearch
                  config={
                  {
                    columns: {
                      thumb: {
                        label: '',
                        image: {
                          src: (item) => (`/api/items/thumbnail/${item.id}`),
                          class: 'rounded',
                          style: { maxHeight: '5rem', maxWidth: '5rem' },
                        },
                        translate: false,
                      },
                      id: { label: props.t('ID'), sort: true },
                      manufacturer: { label: props.t('Mnfr'), sort: true },
                      part_number: { label: props.t('Part Number'), sort: true },
                      tags: {
                        label: 'Tags',
                        format: (x) => (x.map((r) => (r.label))),
                        badges: {
                          class: 'bg-info bg-soft text-dark p-2',
                        },
                      },
                      actions: {
                        label: props.t('Actions'),
                        actions: [
                          {
                            key: 'edit',
                            icon: 'mdi mdi-check-bold',
                            class: 'btn btn btn-soft-dark',
                            alt: props.t('Select'),
                            click: (item) => {
                              const linkedItemSummary = toLinkedItemSummary(item);

                              setFieldValue(
                                `items[${index}].supplier_item.linked_item`,
                                linkedItemSummary,
                              );
                              setLinkedItem(linkedItemSummary);
                              setItemSearch(false);
                            },
                          },
                        ],
                      },
                    },
                    pagination: {
                      sort: 'id',
                      direction: 'desc',
                      perPage: 4,
                    },
                  }
                  }
                />
              </Col>
            </Row>
          )}
        </div>
      )}

      {createMode === false && (
        <BaseGrid
          url={`/api/sourcing/supplier/${values.supplier_id}/items`}
          hasSearch
          shouldPaginate={false}
          skipSort
          create={handleCreate}
          config={
            {
              columns: {
                id: { label: 'ID', sort: true },
                supplier_sku: { label: 'Supplier Sku', sort: true },
                linked_item: {
                  label: props.t('Linked Item'),
                  format: (x) => (x === null ? props.t('Not Linked') : x.part_number),
                },
                notes: { label: 'Notes', sort: true },
                actions: {
                  label: props.t('Actions'),
                  actions: [
                    {
                      key: 'select',
                      icon: 'mdi mdi-check-bold',
                      class: 'btn btn-sm btn-soft-dark',
                      alt: props.t('Select'),
                      click: onChange,
                    },
                  ],
                },
              },
              pagination: {
                sort: 'id',
                direction: 'desc',
                perPage: 3,
              },
            }
          }
        />
      )}
    </div>
  );

  return jsx;
}

SupplierItemSelector.defaultProps = {
  t: (x) => (x),
  onChange: () => {},
};

SupplierItemSelector.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onChange: PropTypes.func,
  index: PropTypes.number.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(SupplierItemSelector));
